import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { FilterQuery, QueryOptions } from '../../repository/types'
import type { User } from '../User'

@InputType()
export class GetUsersArgs extends ActionArgs {
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<User>

  @Field(() => GraphQLJSON, { nullable: true })
  options?: QueryOptions<User>
}

export interface IGetUsers extends IAction<User[], GetUsersArgs> {}
